(function() {
  'use strict';

  angular.module('component.admin', []);
})();
